import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _options;

import OrderTypes from '../../types/OrderTypes';

var getText = function getText(_ref) {
  var record = _ref.record,
      column = _ref.column,
      database = _ref.database;
  var text = database.getFieldData(record.key, column.key).text || '';
  return text.toLowerCase();
};

var options = (_options = {}, _defineProperty(_options, OrderTypes.ASC, 'A-Z'), _defineProperty(_options, OrderTypes.DESC, 'Z-A'), _options);

var strategies = function strategies(columnType, database) {
  var _ref2;

  var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getText;

  var orderBy = function orderBy(order) {
    return function (recordA, recordB, columnKey) {
      var column = database.getColumn(columnKey);
      var fieldA = database.getField(recordA.key, columnKey);
      var fieldB = database.getField(recordB.key, columnKey);
      var textA = fn({
        field: fieldA,
        record: recordA,
        column: column,
        database: database
      });
      var textB = fn({
        field: fieldB,
        record: recordB,
        column: column,
        database: database
      });
      if (!textA && !textB) return 0;
      var aLowerThanB = textA < textB ? -1 : 1;
      return aLowerThanB * (order === OrderTypes.ASC ? 1 : -1);
    };
  };

  return _ref2 = {}, _defineProperty(_ref2, OrderTypes.ASC, orderBy(OrderTypes.ASC)), _defineProperty(_ref2, OrderTypes.DESC, orderBy(OrderTypes.DESC)), _ref2;
};

export default {
  options: options,
  strategies: strategies
};